import { useRef, useState, useEffect } from 'react';
import type { RefObject } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

//  ref is the reference to the element whose height and with is required
//  const divRef = useRef(null);
//  const { height, width } = useDimension(divRef);
//  <div ref={divRef}>)

const useDimension = (ref: RefObject<HTMLElement | null>): { width: number; height: number } => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    resizeObserverRef.current = new ResizeObserver((entries: ResizeObserverEntry[] = []) => {
      entries.forEach((entry) => {
        const { width, height } = entry.contentRect;
        setDimensions({ width, height });
      });
    });

    if (ref && ref.current) {
      resizeObserverRef.current.observe(ref.current);
    }
    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, [ref]);

  return dimensions;
};

export default useDimension;
